<template>
  <div>
    <!--资讯列表-->
    <!--面包屑-->
    <section class="crumbs-wrap">
      <article class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'Home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'exhibition' }">企业展示</el-breadcrumb-item>
          <el-breadcrumb-item>资讯列表</el-breadcrumb-item>
        </el-breadcrumb>
      </article>
    </section>
    <section class="main-wrap">
      <div class="main clearfloat">
        <article class="main-tab">
          <div
            v-for="( item , itemIndex ) in listTab"
            :key="itemIndex"
            :class="[{'main-tab-btn-xz':tabXz==itemIndex}]"
            class="main-tab-btn"
            @click="tabClick(itemIndex)"
          >
            {{ item.title }}
          </div>
        </article>
        <article class="main-con">
          <div class="con">
            <div v-for="(con , conIndex) in listTab" v-show="tabXz==conIndex" :key="conIndex" class="con-box">
              <div class="con-box-minHeight">
                <div v-for="(list,listIndex) in con.list" :key="listIndex" class="con-list clearfloat">
                  <div class="con-list-img"><img :src="list.imgUrl | getImg" alt=""></div>
                  <div class="con-list-box">
                    <p class="con-title" @click="seeClick(list.id)">{{ list.title }}</p>
                    <p class="con-txt">{{ list.content | ellipsisHtml }}</p>
                    <p class="con-sj">{{ list.releaseTime }}</p>
                    <span class="con-details" @click="seeClick(list.id)">查看详情>></span>
                  </div>
                </div>
              </div>
              <el-pagination
                :current-page="con.pageNo"
                :page-size="con.pageSize"
                :total="con.total"
                layout="total, prev, pager, next, jumper"
                @current-change="CurrentChange($event,conIndex)"
              />
            </div>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { listNotice, listComNews, listIndustry } from '@/api/enterprise/list' // 请求接口
export default {
  name: 'List',
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 80) {
        return value.slice(0, 80) + '...'
      }
      return value
    },
    ellipsisHtml(value) {
      if (!value) return ''
      var msg = value.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '').replace(/^\s+|\s+$/g, '')
      if (msg.length > 50) {
        return msg.slice(0, 50) + '...'
      }
      return msg
    }
  },
  data() {
    return {
      // tab切换
      tabXz: 0,
      listTab: [
        { title: '平台公告',
          pageNo: 1,
          pageSize: 20,
          total: 0,
          list: []
        }, { title: '企业新闻',
          pageNo: 1,
          pageSize: 20,
          total: 0,
          list: []
        },
        { title: '行业动态',
          pageNo: 1,
          pageSize: 20,
          total: 0,
          list: []
        }
      ]

    }
  },
  created() {
    // 获取初始化数据
    this.listNoticeGet()
    this.listComNewsGet()
    this.listIndustryGet()
  },
  mounted() {

  },
  methods: {
    // 侧边栏切换
    tabClick(index) {
      this.tabXz = index
      if (index === 0) {
        this.listNoticeGet()
      } else if (index === 1) {
        this.listComNewsGet()
      } else if (index === 2) {
        this.listIndustryGet()
      }
    },
    // 查看详情
    seeClick(data) {
      this.$router.push({
        name: 'detailsSee', query: { seeID: data }
      })
    },
    // 分页
    CurrentChange(val, index) {
      if (index === 0) {
        // 公告
        this.listNoticeGet(val)
      } else if (index === 1) {
        // 企业新闻
        this.listComNewsGet(val)
      } else if (index === 2) {
        // 行业动态
        this.listIndustryGet(val)
      }
    },
    // 公告
    listNoticeGet(val) {
      const pageNo = val || 1
      listNotice({ location: 1 }, pageNo).then(res => {
        this.listTab[0].list = res.result.rows
        this.listTab[0].pageNo = res.result.pageNo
        this.listTab[0].pageSize = res.result.pageSize
        this.listTab[0].total = res.result.total
        // console.log(res)
      }).catch(error => {
        console.log(error)
      })
    },
    // 企业新闻
    listComNewsGet(val) {
      const pageNo = val || 1
      listComNews({ location: 1 }, pageNo).then(res => {
        this.listTab[1].list = res.result.rows
        this.listTab[1].pageNo = res.result.pageNo
        this.listTab[1].pageSize = res.result.pageSize
        this.listTab[1].total = res.result.total
      }).catch(error => {
        console.log(error)
      })
    },
    // 行业动态
    listIndustryGet(val) {
      const pageNo = val || 1
      listIndustry({ location: 1 }, pageNo).then(res => {
        this.listTab[2].list = res.result.rows
        this.listTab[2].pageNo = res.result.pageNo
        this.listTab[2].pageSize = res.result.pageSize
        this.listTab[2].total = res.result.total
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  .crumbs-wrap{
    width: 100%;
    .crumbs{
      width: 1200px;
      margin: 0 auto;
      padding: 40px 0;
    }
  }
  .main-wrap{
    width: 100%;
    .main{
      width: 1200px;
      margin: 0 auto;
      margin-top: 20px;
      .main-tab{
        width: 180px;
        height: auto;
        float: left;
        .main-tab-btn{
          width: 180px;
          height: 58px;
          line-height: 58px;
          text-align: center;
          font-size: 16px;
          border-radius:2px;
          cursor: pointer;
          &.main-tab-btn-xz{
            color: #fff;
            background: #BE2316;
          }
        }
      }
      .main-con{
        float: right;
        width: 960px;
        height: auto;
        .con{
          width: 100%;
          margin-bottom: 20px;
          .con-box-minHeight{
            min-height: 500px;
          }
          .con-list{
            width: 100%;
            height: 166px;
            margin-bottom: 20px;
            padding: 20px;
            border:1px solid #E9E9E9;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            .con-list-img{
              width: 166px;
              height: 117px;
              float: left;
              overflow: hidden;
              img{
                width: 100%;
              }
            }
            .con-list-box{
              position: relative;
              width: 720px;
              height: 120px;
              margin-left: 20px;
              float: left;
              .con-title{
                font-weight: bold;
                font-size: 16px;
                padding-bottom: 20px;
                cursor: pointer;
              }
              .con-title:hover{
                color: #BE2316;
              }
              .con-txt{
                font-size: 14px;
                color: #666;
                line-height: 20px;
                padding-bottom: 5px;
              }
              .con-sj{
                position: absolute;
                bottom: 0;
                left: 0;
                font-size: 14px;
                color: #666;
                line-height: 20px;
              }
              .con-details{
                position: absolute;
                right: 0;
                bottom: 0;
                font-size: 14px;
                color: #4F83E9;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
</style>
